import * as React from 'react'
import { getToken } from 'web-fns/dist/auth'
import { domainHelper } from './domainHelper'

export const getSearchToken = async () => {
  const [searchToken, setSearchToken] = React.useState<string>('')
  const jwt = getToken()
  const fetchSearchToken = async () => {
    try {
      const response = await fetch(`https://app.90seconds.${domainHelper()}/api/search-token/`, {
        method: 'POST',
        headers: {
          authorization: `Bearer ${jwt}`,
        },
      })
      const data = await response.json()
      return data
    } catch (error) {
      console.error('Failed to fetch search token:', error)
      return null
    }
  }

  React.useEffect(() => {
    fetchSearchToken().then(tokenData => {
      tokenData && setSearchToken(tokenData.token)
    })
  }, [])

  return searchToken
}



// WEBPACK FOOTER //
// ./src/helpers/getSearchToken.tsx